import axios from "axios";
import React, { Component } from "react";
import AlertPopup from "./AlertPopup";
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';


class CarrierSubPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fullName: "",
      address: "",
      district: "",
      state: "",
      pinCode: "",
      mobile: "",
      languages: "",
      gender: "",
      experience: "",
      age: "",
      resume: null,
      certificate: null,
      qualifications: null,
      selfie: null,
      resumeUrl: "",
      certificateUrl: "",
      qualificationsUrl: "",
      selfieUrl: "",
      degree: "",
       message: "",
      errors: {},
      showAlert: false,
      alertTitle: '',
      alertMessage: '',
      alertType: '', // success or error
      alertIcon: null,
    };
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

 handleImageChange = async (e) => {
  const { name, files } = e.target;
  const file = files[0];
  if (!file) return;

  const formData = new FormData();
  formData.append('files', file);

  const BackendUrl = process.env.REACT_APP_BACKEND_API_URL;

  try {
    const response = await axios.post(`${BackendUrl}/files/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    if (response.status === 200) {
      const uploadedImageUrl = response.data.data[0].location;
      this.setState({ [name]: file, [`${name}Url`]: uploadedImageUrl });
    } else {
      this.setState({showAlert: true,alertTitle: 'ERROR',alertMessage: 'File upload failed.',alertType: 'error',alertIcon: faTimesCircle,
      });
        }
    } catch (error) {
      console.error('Upload error:', error);
      this.setState({showAlert: true,alertTitle: 'ERROR',alertMessage: 'Error uploading file.',alertType: 'error',alertIcon: faTimesCircle,});
  }
};

  handleSubmit = (e) => {
    e.preventDefault();
    const BackendUrl = process.env.REACT_APP_BACKEND_API_URL;
    const {fullName,address,district,state,pinCode,mobile,languages,gender,experience,age,resumeUrl,degree, certificateUrl, qualificationsUrl, selfieUrl} = this.state;

    const requiredFields = [
      { key: "fullName", label: "Full Name" },
      { key: "address", label: "Address" },
      { key: "district", label: "District" },
      { key: "state", label: "State" },
      { key: "pinCode", label: "Pin Code" },
      { key: "mobile", label: "Mobile Number" },
      { key: "languages", label: "Languages Known" },
      { key: "gender", label: "Gender" },
      { key: "experience", label: "Teaching Experience" },
      { key: "age", label: "Age" },
      { key: "resume", label: "Resume" },
      { key: "certificate", label: "Certificate" },
      { key: "qualifications", label: "Qualifications" },
      { key: "selfie", label: "Selfie" },
      { key: "degree", label: "Qualification" }
    ];

    const missingField = requiredFields.find(f => !this.state[f.key]);
    if (missingField) {
      this.setState({showAlert: true,alertTitle: 'ERROR',alertMessage: `Please fill: ${missingField.label}`,alertType: 'error',alertIcon: faTimesCircle,});
      return;
    }
    // Pin code validation: allow only 6 digits
    if (!/^\d{6}$/.test(this.state.pinCode)) {
      this.setState({showAlert: true,alertTitle: 'ERROR',alertMessage: 'Pin Code must be a 6-digit number.',alertType: 'error',alertIcon: faTimesCircle,});
      return;
    }
    if (!/^\d{1,15}$/.test(this.state.mobile)) {
      this.setState({showAlert: true,alertTitle: 'ERROR',alertMessage: 'Please enter a valid mobile number.',alertType: 'error',alertIcon: faTimesCircle,});
      return;
    }

    const dataToPass =  {
      "fullName": fullName,
      "address": address,
      "district": district,
      "state": state,
      "pinCode": pinCode,
      "mobile": mobile,
      "languages": languages,
      "gender": gender,
      "experience": experience,
      "age": age,
      "resume" : resumeUrl,
      "certificate" : certificateUrl,
      "qualifications" : qualificationsUrl,
      "selfie" : selfieUrl,
      "degree": degree
    }
    axios
      .post(`${BackendUrl}/carrier-application`, dataToPass)
      .then((response) => {
        this.setState({
          fullName: "",
          address: "",
          district: "",
          state: "",
          pinCode: "",
          mobile: "",
          languages: "",
          gender: "",
          experience: "",
          age: "",
          resume: "",
          certificate: "",
          qualifications: "",
          selfie: "",
          resumeUrl: "",
          certificateUrl: "",
          qualificationsUrl: "",
          selfieUrl: "",
          degree: "",
          showAlert: true,
          alertTitle: 'SUCCESS',
          alertMessage: 'Form submitted successfully!',
          alertType: 'success',
          alertIcon: faCheckCircle,
        });
      })
      .catch((error) => {
        console.error("Submission error:", error);
        this.setState({showAlert: true,alertTitle: 'ERROR',alertMessage: 'Submission failed. Please try again.',alertType: 'error',alertIcon: faTimesCircle,});
      });
  };

  render() {
    const {
      fullName,
      address,
      district,
      state,
      pinCode,
      mobile,
      languages,
      gender,
      degree,
      experience,
      age,alertTitle, alertMessage, alertIcon, alertType
    } = this.state;

    return (
      <div className="container-fluid contact py-3">
        <div className="container">
          <div className="text-center mx-auto mb-3" style={{ maxWidth: "700px" }}>
            <p className="fs-5 text-uppercase text-primary">Teacher Application Form</p>
            <h1>Submit Your Details to Join Us</h1>
          </div>
          <form onSubmit={this.handleSubmit} encType="multipart/form-data">
            <div className="row g-4 col-lg-10 m-auto shadow p-3 br-10">
              <div className="col-sm-6">
                <label className="mb-2 text-primary">Full Name</label>
                <input
                  type="text"
                  className="form-control bg-transparent p-3"
                  name="fullName"
                  value={fullName}
                  onChange={this.handleChange}
                  placeholder="Full Name"
                />
              </div>

              <div className="col-sm-6">
                <label className="mb-2 text-primary">Address</label>
                <input
                  type="text"
                  className="form-control bg-transparent p-3"
                  name="address"
                  value={address}
                  onChange={this.handleChange}
                  placeholder="Address"
                />
              </div>

              <div className="col-sm-6">
                <label className="mb-2 text-primary">District</label>
                <input
                  type="text"
                  className="form-control bg-transparent p-3"
                  name="district"
                  value={district}
                  onChange={this.handleChange}
                  placeholder="District"
                />
              </div>

              <div className="col-sm-6">
                <label className="mb-2 text-primary">State</label>
                <input
                  type="text"
                  className="form-control bg-transparent p-3"
                  name="state"
                  value={state}
                  onChange={this.handleChange}
                  placeholder="State"
                />
              </div>

              <div className="col-sm-6">
                <label className="mb-2 text-primary">Pin Code</label>
                <input
                  type="number"
                  className="form-control bg-transparent p-3"
                  name="pinCode"
                  value={pinCode}
                  onChange={this.handleChange}
                  placeholder="Pin Code"
                />
              </div>

              <div className="col-sm-6">
                <label className="mb-2 text-primary">Mobile Number</label>
                <input
                  type="number"
                  className="form-control bg-transparent p-3"
                  name="mobile"
                  maxLength={12}
                  value={mobile}
                  onChange={this.handleChange}
                  placeholder="Mobile Number"
                />
              </div>

              <div className="col-sm-6">
                <label className="mb-2 text-primary">Languages Known</label>
                <input
                  type="text"
                  className="form-control bg-transparent p-3"
                  name="languages"
                  value={languages}
                  onChange={this.handleChange}
                  placeholder="Languages"
                />
              </div>

              <div className="col-sm-6">
                <label className="mb-2 text-primary">Gender</label>
                <select
                  className="form-select bg-transparent p-3"
                  name="gender"
                  value={gender}
                  onChange={this.handleChange}
                >
                  <option value="">Select</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>

              <div className="col-sm-6">
                <label className="mb-2 text-primary">Teaching Experience</label>
                {/* <input
                  type="text"
                  className="form-control bg-transparent p-3"
                  name="experience"
                  value={experience}
                  onChange={this.handleChange}
                  placeholder="Experience (e.g., 2 years)"
                /> */}
                <select
                  className="form-select bg-transparent p-3"
                  name="experience"
                  value={experience}
                  onChange={this.handleChange}
                >
                  <option value="">Select</option>
                  <option value="0 To 2 Years">0 To 2 Years</option>
                  <option value="2 To 5 Years">2 To 5 Years</option>
                  <option value="5 Years And Above">5 Years And Above</option>
                </select>
              </div>

              <div className="col-sm-6">
                <label className="mb-2 text-primary">Age</label>
                <input
                  type="number"
                  className="form-control bg-transparent p-3"
                  name="age"
                  value={age}
                  onChange={this.handleChange}
                  placeholder="Your Age"
                />
                
              </div>

              {/* File inputs at the end */}
              <div className="col-sm-6">
                <label className="mb-2 text-primary">Resume</label>
                <input
                  type="file"
                  className="form-control bg-transparent p-3"
                  name="resume"
                  onChange={this.handleImageChange}
                />
                {this.state.resumeUrl && <img src={this.state.resumeUrl} className="w-25 mt-2" alt="selfie Preview" />}
              </div>

              <div className="col-sm-6">
                <label className="mb-2 text-primary">Certificate</label>
                <input
                  type="file"
                  className="form-control bg-transparent p-3"
                  name="certificate"
                  onChange={this.handleImageChange}
                />
                {this.state.certificateUrl && <img src={this.state.certificateUrl} className="w-25 mt-2" alt="selfie Preview" />}
              </div>
                {/* degree */}
                <div className="col-sm-6">
                  <label className="mb-2 text-primary">Select Qualification</label>
                  <select
                    className="form-select bg-transparent p-3"
                    name="degree"
                    value={degree}
                    onChange={this.handleChange}
                  >
                    <option value="">Select</option>
                    {
                    gender === "Female" ? (
                      <>
                        <option value="Muftia">Muftia</option>
                       <option value="Aalima">Aalima</option>
                        <option value="Hafiza">Hafiza</option>
                        <option value="Qaria">Qaria</option>
                      </>
                    ) : (
                      <>
                        <option value="Mufti">Mufti</option>
                        <option value="Aalim">Aalim</option>
                        <option value="Hafiz">Hafiz</option>
                        <option value="Qari">Qari</option>
                      </>
                    )
                    }
                    <option value="Others">Others</option>
                  </select>
                </div>

              <div className="col-sm-6">
                <label className="mb-2 text-primary">Qualifications</label>
                <input
                  type="file"
                  className="form-control bg-transparent p-3"
                  name="qualifications"
                  onChange={this.handleImageChange}
                />
                {this.state.qualificationsUrl && <img src={this.state.qualificationsUrl} className="w-25 mt-2" alt="selfie Preview" />}
              </div>

              <div className="col-sm-6">
                <label className="mb-2 text-primary">Selfie</label>
                <input
                  type="file"
                  className="form-control bg-transparent p-3"
                  name="selfie"
                  onChange={this.handleImageChange}
                />
                {/* Uploaded Img Priew here */}
                {this.state.selfieUrl && <img src={this.state.selfieUrl} className="w-25 mt-2" alt="selfie Preview" />}
              </div>

              <div className="col-12 text-center my-4">
                <button
                  className="btn btn-primary border-0 py-3 px-5"
                  type="submit"
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
           {/* Alert Popup */}
        {this.state.showAlert && (
          <AlertPopup
            title={alertTitle}
            message={alertMessage}
            icon={alertIcon}
            type={alertType}
            onClose={() => this.setState({ showAlert: false })}
          />
        )}
        </div>
      </div>
    );
  }
}

export default CarrierSubPage;
